import { Action } from '@ngrx/store';

export enum DashboardActionTypes {
  AddToSearchText = 'AddToSearchText',
  SetSearchText = 'SetSearchText',
  ClearSearchText = 'ClearSearchText',
  LoadWorkOrders = 'LoadWorkOrders',
}

export class AddToSearchText implements Action {
  readonly type = DashboardActionTypes.AddToSearchText;
  constructor(public search: string) {}
}

export class SetSearchText implements Action {
  readonly type = DashboardActionTypes.SetSearchText;
  constructor(public search: string) {}
}

export class ClearSearchText implements Action {
  readonly type = DashboardActionTypes.ClearSearchText;
  constructor() {}
}

export type DashboardActions = AddToSearchText | SetSearchText | ClearSearchText;
